/* eslint-disable no-console */
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {
  Autocomplete,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Link,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store, useAppSelector } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setMoveTabValue } from 'src/store/MoveTab';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import { DocumentUploadComponent } from './component/DocumentUploadComponent';
import './DocumentUpload.scss';
import DocumentUploadList from './DocumentUploadList';
import IncludePHIDialog from './IncludePHIDialog';
import DocManagementService from './service/DocManagementService';
import VersionControl from './VersionControl';
import { useTranslation } from 'react-i18next';
import { useGetStudiesQuery } from 'src/components/Services/Utils';

export const DocumentUpload = (props: any) => {
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const dispatch = useDispatch();
  const [dataGridComponent, setDataGridComponent] = useState(props.dataGridComponent ? false : true);
  const [openEditDocVersion, setOpenEditDocVersion] = useState(props.openVersion ? true : false);
  const [documentToDisplay, setDocumentToDisplay] = useState<any>([]);
  const [openVersion, setOpenVersion] = useState(false);
  const [selectData, setSelectData] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [enable, setEnable] = useState<boolean>(false);
  const [artifactNameList, setArtifactNameList] = useState<any>([]);
  const [artifactName, setArtifactName] = useState<any>();
  const [docName, setDocName] = useState<any>();
  const [list, setList] = useState([]);
  const [resData, setResData] = useState<any>(null);
  const [isFileUploaded, setFileUploaded] = useState<any>(null);
  const [result, setResult] = useState<any>([]);
  const [editDoc, setEditDoc] = useState<any>({});
  const [disableSave, setDisableSave] = useState(true);
  const { row, isEdit } = editDoc;
  const [IsVersionCheck, setIsVersionCheck] = useState(false);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [loading, setLoading] = useState<any>(false);
  const [checked, setChecked] = useState(false);
  const [openPHI, setOpenPHI] = useState(false);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const [disablePHI, setDisablePHI] = useState(false);
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const [isUploaded, setUploaded] = useState<boolean>(false);
  const [ischecked, setIsChecked] = useState<boolean>();
  const [rowCount, setRowCount] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [isFileUploading, setFileUploading] = useState<boolean>(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const InitialState = {
    isf_artifact_number: '',
    isf_document_name: '',
    isf_document_type: '',
    isf_document_subtype: '',
    isf_doc_date: '',
    isf_doc_country: SearchHierarchyDetail?.data[0]?.Country ? SearchHierarchyDetail?.data[0]?.Country : '',
    isf_doc_study: SearchHierarchyDetail?.data[0]?.Study ? SearchHierarchyDetail?.data[0]?.Study : '',
    isf_doc_site: SearchHierarchyDetail?.data[0]?.Site ? SearchHierarchyDetail?.data[0]?.Site : '',
    isf_doc_level: 'Site',
    isf_artifact_name: '',
    isf_doc_version_number: '',
    isf_doc_milestone: '',
    isf_doc_viewer_req_certified_copy: '',
    isf_doc_viewer_red_certified_copy: '',
    isf_doc_viewer_doc_phi_redacted: ''
  };
  const [metaData, setMetaData] = useState<any>(InitialState);
  const rowDetails: any = useSelector((state: AppState) => state.rowDetail);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (rowDetails.data[0] != null && rowDetails.data[0] != undefined) {
      setIsVersionCheck(true);
      rowDetails.data[0]?.isf_doc_viewer_includes_phi ? setChecked(true) : setChecked(false);
      setMetaData({
        ...metaData,
        id: rowDetails.data[0]?.id,
        isf_artifact_number: rowDetails.data[0]?.isf_artifact_number,
        isf_document_type: rowDetails.data[0]?.isf_doc_type,
        isf_document_subtype: rowDetails.data[0]?.isf_doc_subtype,
        isf_doc_country: rowDetails.data[0]?.isf_doc_country,
        isf_doc_study: rowDetails.data[0]?.isf_doc_study,
        isf_doc_site: rowDetails.data[0]?.isf_doc_site,
        isf_doc_level: rowDetails.data[0]?.isf_doc_level,
        isf_artifact_name: artifactName ? artifactName : rowDetails.data[0]?.isf_artifact_name,
        isf_doc_milestone: rowDetails.data[0]?.isf_doc_milestone,
        fileId: rowDetails.data[0]?.fileId,
        isf_doc_date: rowDetails.data[0]?.isf_doc_viewer_date.split('T')[0],
        isf_doc_viewer_red_certified_copy: rowDetails.data[0]?.isf_doc_viewer_red_certified_copy,
        isf_document_id: rowDetails.data[0]?.isf_document_id,
        isf_doc_viewer_includes_phi: rowDetails.data[0]?.isf_doc_viewer_includes_phi,
        isf_doc_viewer_doc_phi_redacted: rowDetails.data[0]?.isf_doc_viewer_doc_phi_redacted
      });
      setArtifactName(rowDetails.data[0]?.isf_artifact_name ? rowDetails.data[0]?.isf_artifact_name : artifactName);
    }
  }, [rowDetails]);

  const onFileUploadSuccess = (fileUploaded: any) => {
    setFileUploaded(fileUploaded);
    setMetaData({ ...metaData, isf_doc_version_number: `1.0`, isf_doc_date: new Date() });
  };

  const getSearchHierarchy = (study: string, country: string, site: string) => {
    if (isEdit && !IsVersionCheck && study === '--') {
      setMetaData({
        ...metaData,
        isf_artifact_name: '',
        isf_doc_milestone: '',
        isf_document_type: '',
        isf_document_subtype: '',
        isf_artifact_number: '',
        isf_doc_study: '--',
        isf_doc_country: '--',
        isf_doc_site: '--'
      });
      documentValue(study, country, site, 0, pageSize);
    } else {
      setMetaData({
        ...metaData,
        isf_doc_study: study,
        isf_doc_country: country,
        isf_doc_site: site,
        isf_artifact_name: '',
        isf_doc_milestone: '',
        isf_document_type: '',
        isf_document_subtype: '',
        isf_artifact_number: ''
      });
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
    }
  };

  const handleChangeCheck = () => {
    setOpenPHI(true);
    setDisableSave(false);
    setDisableSubmit(false);
  };

  const handleUploadFile = async (Res: any, Meta: any, artifactName: any, isSubmit: boolean, checked: boolean) => {
    setDisableSubmit(true);
    // called when submit button is clicked
    const response: any = await docService.fileUpload(
      isFileUploaded,
      progress => {
        setProgress(progress);
      },
      metaData.isf_doc_level,
      selectedStudy,
      selectedCountry,
      selectedSite,
      process.env.REACT_APP_NAME,
      'DocumentUpload',
      props.entity
    );
    setFileUploading(false);
    if (response.data) {
      const data = response.data.data;

      setResData(data);
      setConfirmExitValue(dispatch, true);
      setMoveTabValue(dispatch, false);

      metaData.isf_doc_version_number = data.isf_doc_version_number;
      metaData.isf_doc_date = data.updated_on;
      setDisablePHI(false);
      const docData: any = {
        file_master_id: data.id,
        document_data: {
          isf_artifact_number: Meta.isf_artifact_number,
          isf_document_name: Meta.isf_document_name,
          isf_doc_type: Meta.isf_document_type,
          isf_doc_subtype: Meta.isf_document_subtype,
          isf_doc_viewer_includes_phi: checked,
          isf_doc_viewer_red_certified_copy: Meta.isf_doc_viewer_red_certified_copy
            ? Meta.isf_doc_viewer_red_certified_copy
            : 'N',
          isf_doc_status: 'Uploaded',
          isf_doc_country: Meta.isf_doc_country,
          isf_doc_study: Meta.isf_doc_study,
          isf_doc_site: Meta.isf_doc_site,
          isf_doc_viewer_department: 'None',
          isf_doc_viewer_language: 'English',
          isf_doc_viewer_approval_cycle: 0,
          isf_doc_viewer_product_detail: 'test1',
          isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
          isf_doc_viewer_format: data.isf_doc_type,
          isf_doc_viewer_inspection_ready: '',
          isf_doc_viewer_ir_issue_type: '',
          isf_doc_level: Meta.isf_doc_level,
          isf_artifact_name: artifactName,
          isf_doc_version_number: Meta.isf_doc_version_number,
          isf_doc_milestone: Meta.isf_doc_milestone,
          isf_document_id: 'str',
          isf_doc_viewer_doc_phi_redacted: Meta.isf_doc_viewer_doc_phi_redacted
            ? Meta.isf_doc_viewer_doc_phi_redacted
            : 'N',
          isf_doc_viewer_created_by: userName
        }
      };
      CompareDocumentDetails(metaData, docData, isSubmit);
    } else if (response.error) {
      if (response.error === 'Request failed with status code 500') {
        store.dispatch(setSnackbarMessage('File name with more than 100 characters is not allowed', 'error'));
      } else {
        store.dispatch(
          setSnackbarMessage(
            t('fileUploadError', {
              returnObjects: true,
              fileName: isFileUploaded.name
            }),
            'error'
          )
        );
      }
      setError(response.error?.message);
    }
  };

  const postData = async (docData: any, isSubmit: boolean) => {
    const res: any = await docService.createMasterDocument(
      docData,
      process.env.REACT_APP_NAME,
      'DocumentUpload',
      metaData.isf_document_name
    );
    if (res.error) {
      setDisableSubmit(false);
      store.dispatch(setSnackbarMessage('Error in uploading document.', 'error'));
    } else {
      setConfirmExitValue(dispatch, false);
      setFileUploaded(null);
      store.dispatch(setSnackbarMessage('Document is uploaded successfully.', 'success'));
      documentValue(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site,
        0,
        pageSize
      );
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      setDisablePHI(false);
      ClearData();
    }
  };

  const ClearData = () => {
    setMetaData({ ...InitialState });
    setChecked(false);
    setDisablePHI(false);
    setConfirmExitValue(dispatch, false);
    setConfirmExitPopupVal(dispatch, false);
  };

  const handleUpdateFile = (Meta: any, isSave: any) => {
    const docData: any = {
      file_master_id: Meta.fileId,
      document_data: {
        isf_artifact_number: Meta.isf_artifact_number ? Meta.isf_artifact_number : Meta.isf_doc_artifact_number,
        isf_document_name: Meta.isf_document_name,
        isf_doc_type: Meta.isf_doc_type ? Meta.isf_doc_type : Meta.isf_document_type,
        isf_doc_subtype: Meta.isf_doc_subtype ? Meta.isf_doc_subtype : Meta.isf_document_subtype,
        isf_doc_viewer_req_certified_copy: Meta.isf_doc_viewer_req_certified_copy,

        isf_doc_viewer_red_certified_copy: Meta.isf_doc_viewer_red_certified_copy
          ? Meta.isf_doc_viewer_red_certified_copy
          : 'N',
        isf_doc_status: Meta.isf_doc_status,
        isf_doc_country: Meta.isf_doc_country,
        isf_doc_study: Meta.isf_doc_study,
        isf_doc_site: Meta.isf_doc_site,
        isf_doc_viewer_department: row.isf_doc_viewer_department,
        isf_doc_viewer_language: 'English',
        isf_doc_viewer_approval_cycle: 0,
        isf_doc_viewer_product_detail: '',
        isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
        isf_doc_viewer_format: Meta.isf_doc_format,
        isf_doc_viewer_inspection_ready: 'test1',
        isf_doc_viewer_ir_issue_type: 'ISF RM v1.0',
        isf_doc_level: Meta.isf_doc_level,
        isf_artifact_name: artifactName ? artifactName : Meta.isf_artifact_name,
        isf_doc_version_number: Meta.isf_doc_version_number,
        isf_doc_milestone: Meta.isf_doc_milestone,
        isf_document_id: Meta.isf_document_id,
        isf_doc_viewer_includes_phi: checked,
        isf_doc_viewer_doc_phi_redacted: Meta.isf_doc_viewer_doc_phi_redacted
          ? Meta.isf_doc_viewer_doc_phi_redacted
          : 'N',
        id: Meta.id,
        isf_doc_viewer_last_modified_by: userName
      }
    };
    getDocumentDetailsforVersion(Meta, docData, isSave);
  };

  const updateDocumentData = async (docData: any, isSave: any) => {
    const res = await docService.updateMasterDocument(
      docData,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name,
      false
    );
    if (res.data) {
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
      setIsVersionCheck(false);

      documentValue(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site,
        0,
        pageSize
      );
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      setDisablePHI(false);
      ClearData();
      handleClose();
      handleClearData();
      setIsChecked(false);
    } else {
      if (res.error && (res.error?.response.status !== 401 || res.error?.response.status !== 403)) {
        store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
      }
    }
  };

  const handleClosePropVersion = () => {
    setOpenEditDocVersion(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (dataGridComponent || props.onClicked) {
      props.routeInfo && props.routeInfo('');
      setDataGridComponent(true);
    } else {
      props.routeInfo && props.routeInfo('doc_upload');
    }
  }, [dataGridComponent, props.onClicked]);

  useEffect(() => {
    if (
      SearchHierarchyDetail?.data[0]?.Site !== '' &&
      SearchHierarchyDetail?.data[0]?.Site !== '--' &&
      SearchHierarchyDetail?.data[0]?.Site !== undefined
    ) {
      if (page * pageSize > rowCount - 1) {
        setPage(0);
        documentValue(
          SearchHierarchyDetail?.data[0]?.Study,
          SearchHierarchyDetail?.data[0]?.Country,
          SearchHierarchyDetail?.data[0]?.Site,
          0,
          pageSize
        );
      } else
        documentValue(
          SearchHierarchyDetail?.data[0]?.Study,
          SearchHierarchyDetail?.data[0]?.Country,
          SearchHierarchyDetail?.data[0]?.Site,
          page * pageSize,
          pageSize
        );
      getArtifactNameList(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site
      );
    } else {
      setArtifactNameList([]);
      setList([]);
    }
  }, [page, pageSize, SearchHierarchyDetail?.data[0]]);

  const handleChangeArtifactName = (value: any) => {
    if (!value) {
      setArtifactName(value);
      setMetaData({
        ...metaData,
        isf_artifact_name: '',
        isf_doc_milestone: '',
        isf_document_type: '',
        isf_document_subtype: '',
        isf_artifact_number: ''
      });

      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...metaData,
            isf_artifact_name: '',
            isf_doc_milestone: '',
            isf_doc_type: '',
            isf_doc_subtype: '',
            isf_artifact_number: ''
          }
        }
      ]);
    }
    else{
      setArtifactName(value);
      setDisableSave(false);
      setDisableSubmit(false);
      getArtifactNameResponse(value);
    } 
  };

  const handleDocumentName = (e: any) => {
    setMetaData({ ...metaData, isf_document_name: e.target.value });
    setDocName(e.target.value);
    setDisableSave(false);
    setDisableSubmit(false);
  };

  const documentValue = async (study: string, country: string, site: string, from: number, size: number) => {
    if (site !== '' && site !== '--' && site !== undefined) {
      setLoading(true);
      const response: any = await docService.getMasterDocumentsByUser(
        study,
        country,
        site,
        false,
        metaData?.isf_doc_level,
        process.env.REACT_APP_NAME,
        'DocumentUpload',
        metaData.isf_document_name,
        true,
        from,
        size
      );
      if (response.data) {
        setLoading(false);
        if (!openEditDocVersion) {
          setDocumentDetail(dispatch, [response.data]);
        }
        const documentDataTotal = response?.data?.selected_data?.map((el: any) => {
          el.file_master.fmId = el.file_master.id;
          el.document_data.fileId = el.file_master.id;
          el.file_master.docFormat = el.file_master.isf_doc_type;
          el.document_data.hashed_uri_key = el.hashed_uri_key;
          return el;
        });
        const comData = documentDataTotal.map(
          (respo: { document_data: any; file_master: any }) => [{ ...respo.file_master, ...respo.document_data }][0]
        );
        setResult(comData);
        setRowCount(response.data.record_count);
      } else {
        setLoading(false);
        setResult([]);
      }
    } else {
      setLoading(false);
      setResult([]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getArtifactNameList(
      SearchHierarchyDetail?.data[0]?.Study,
      SearchHierarchyDetail?.data[0]?.Country,
      SearchHierarchyDetail?.data[0]?.Site
    );
    if (isEdit) {
      if (
        row.isf_document_name !== metaData.isf_document_name ||
        row.isf_artifact_name !== metaData.isf_artifact_name ||
        row.isf_doc_viewer_includes_phi !== metaData.isf_doc_viewer_includes_phi
      ) {
        setConfirmExitValue(dispatch, true);
      } else {
        setConfirmExitValue(dispatch, false);
      }
      if (Number(row.isf_doc_version_number) > 1.0) {
        setIsVersionCheck(true);
      } else {
        setIsVersionCheck(false);
      }
      setArtifactName(row.isf_artifact_name ? row.isf_artifact_name : artifactName);
      setFileUploaded(true);
      setChecked(row.isf_doc_viewer_includes_phi);
      setMetaData({
        ...metaData,
        id: row.id,
        isf_artifact_number: row.isf_artifact_number,
        isf_document_name: row.isf_document_name,
        isf_document_type: row.isf_doc_type,
        isf_document_subtype: row.isf_doc_subtype,
        isf_doc_date: row.isf_doc_viewer_date.split('T')[0],
        isf_doc_country: row.isf_doc_country,
        isf_doc_study: row.isf_doc_study,
        isf_doc_site: row.isf_doc_site,
        isf_doc_level: row.isf_doc_level,
        isf_doc_viewer_includes_phi: row.isf_doc_viewer_includes_phi,
        isf_artifact_name: row.isf_artifact_name ? row.isf_artifact_name : artifactName,
        isf_doc_version_number: row.isf_doc_version_number,
        isf_doc_milestone: row.isf_doc_milestone,
        fileId: row.fileId,
        isf_doc_viewer_red_certified_copy: row.isf_doc_viewer_red_certified_copy,
        isf_doc_viewer_doc_phi_redacted: row.isf_doc_viewer_doc_phi_redacted,
        isf_document_id: row.isf_document_id,
        isf_doc_status: row.isf_doc_status
      });
      setDisableSave(true);
    }
  }, [row]);

  const getArtifactNameList = async (study: string, country: string, site: string) => {
    if (site && site !== null && site !== '--') {
      const result: any = await docService.getArtifactsList(
        metaData.isf_doc_level,
        study,
        country,
        site,
        process.env.REACT_APP_NAME,
        'DocumentDetails',
        metaData.isf_document_name
      );
      if (result.data) {
        setArtifactNameList(result.data);
        setList(result.data);
      } else {
        setArtifactNameList([]);
        setList([]);
      }
    } else {
      setArtifactNameList([]);
      setList([]);
    }
  };

  const getArtifactNameResponse = async (e: any) => {
    const result: any = await docService.getArtifactNameResponse(
      metaData.isf_doc_level,
      e,
      SearchHierarchyDetail?.data[0]?.Study,
      SearchHierarchyDetail?.data[0]?.Country,
      SearchHierarchyDetail?.data[0]?.Site,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );
    if (result.data) {
      setMetaData({
        ...metaData,
        isf_artifact_name: e,
        isf_artifact_number: result.data?.isf_artifact_number,
        isf_document_subtype: result.data?.isf_doc_subtype,
        isf_document_type: result.data?.isf_doc_type,
        isf_doc_milestone: result.data?.isf_doc_milestone
      });
      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...metaData,
            isf_artifact_number: result.data?.isf_artifact_number,
            isf_document_subtype: result.data?.isf_doc_subtype,
            isf_document_type: result.data?.isf_doc_type,
            isf_doc_milestone: result.data?.isf_doc_milestone
          }
        }
      ]);
    }
  };

  const handleClearData = () => {
    setIsChecked(false);
    setStyleUpload('uploadFile');
    setFileUploaded(null);
    setUploaded(false);
    setMetaData({ ...InitialState });
    setChecked(false);
    setDisablePHI(false);
    setIsVersionCheck(false);
    if (!openEditDocVersion) {
      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...InitialState
          }
        }
      ]);
    }
    setEnable(false);
    setEditDoc({ editDoc: { isEdit: false } });
    setConfirmExitValue(dispatch, false);
    setConfirmExitPopupVal(dispatch, false);
    setFileUploading(false);
  };

  /**
   * File upload rejected.
   *
   * @param rejectedFile
   * @param acceptedFiles
   * @param maxFileSize
   * @returns
   */
  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (rejectedFile.size > maxFileSize) {
      message += `File is too big. Max File Size is 5MB`;
    } else if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported.
      Supported file formats are jpg, jpeg, gif, png, bmp, tif, psd, pdf, doc, docx, xls, xlsx.`;
    }
    return message;
  };

  const handleDialogBox = () => {
    setEnable(true);
  };
  const handleClose = () => {
    setEnable(false);
  };

  const handleCloseVersion = () => {
    setOpenVersion(false);
    setMetaData({ ...InitialState });
    if (dataGridComponent) {
      documentValue(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site,
        0,
        pageSize
      );
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      ClearData();
    }
  };

  const CompareDocumentDetails = async (metaData: any, docData: any, isSubmit: any) => {
    const is_scope = metaData.isf_doc_study === '--' ? false : true;
    const data = {
      query_filters: [
        {
          name: 'isf_doc_level',
          value: metaData.isf_doc_level,
          operation: 'equals'
        },
        {
          name: 'isf_artifact_name',
          value: artifactName ? artifactName : rowDetails.data[0]?.isf_artifact_name,
          operation: 'equals'
        }
      ],
      filter_types: ['All']
    };
    const res: any = await docService.getSearchResult(
      data,
      metaData.isf_doc_study,
      metaData.isf_doc_country,
      metaData.isf_doc_site,
      metaData.isf_doc_level,
      is_scope,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );
    if (res.data) {
      setSelectData(res.data.selected_data[0]);
      (metaData.isf_doc_level === res.data?.selected_data[0]?.document_data.isf_doc_level &&
        metaData.isf_doc_study === res.data?.selected_data[0]?.document_data.isf_doc_study &&
        metaData.isf_artifact_name === res.data?.selected_data[0]?.document_data.isf_artifact_name) ||
      metaData.isf_doc_country === res.data?.selected_data[0]?.document_data.isf_doc_country ||
      metaData.isf_doc_site === res.data?.selected_data[0]?.document_data.isf_doc_site
        ? setOpenVersion(true)
        : postData(docData, isSubmit);
    } else {
      postData(docData, isSubmit);
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      ClearData();
    }
  };

  const getDocumentDetailsforVersion = async (metaData: any, docData: any, isSave: any) => {
    const is_scope = metaData.isf_doc_study === '--' ? false : true;
    const country =
      metaData.isf_doc_level === 'Country' || metaData.isf_doc_level === 'Site' ? metaData.isf_doc_country : '--';
    const site = metaData.isf_doc_level === 'Site' ? metaData.isf_doc_site : '--';
    const data = {
      query_filters: [
        {
          name: 'isf_doc_level',
          value: metaData.isf_doc_level,
          operation: 'equals'
        },
        {
          name: 'isf_artifact_name',
          value: artifactName ? artifactName : metaData.isf_artifact_name,
          operation: 'equals'
        }
      ],
      filter_types: ['All']
    };
    const res: any = await docService.getSearchResult(
      data,
      metaData.isf_doc_study,
      metaData.isf_doc_country,
      metaData.isf_doc_site,
      metaData.isf_doc_level,
      is_scope,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );

    if (res.data && !IsVersionCheck) {
      const condition =
        (metaData.isf_doc_level === res.data?.selected_data[0]?.document_data.isf_doc_level &&
          metaData.isf_doc_study === res.data?.selected_data[0]?.document_data.isf_doc_study &&
          metaData.isf_artifact_name === res.data?.selected_data[0]?.document_data.isf_artifact_name) ||
        metaData.isf_doc_country === res.data?.selected_data[0]?.document_data.isf_doc_country ||
        metaData.isf_doc_site === res.data?.selected_data[0]?.document_data.isf_doc_site;

      if (artifactName === undefined && docName !== '') {
        updateDocumentData(docData, isSave);
      } else {
        condition
          ? (metaData.isf_document_name !== res.data?.selected_data[0]?.document_data.isf_document_name &&
              row.isf_document_id === res.data?.selected_data[0]?.document_data.isf_document_id) ||
            metaData.isf_doc_viewer_includes_phi !== checked ||
            metaData.isf_doc_viewer_red_certified_copy !==
              res.data?.selected_data[0]?.document_data.isf_doc_viewer_red_certified_copy ||
            metaData.isf_doc_viewer_doc_phi_redacted !==
              res.data?.selected_data[0]?.document_data.isf_doc_viewer_doc_phi_redacted
            ? updateDocumentData(docData, isSave)
            : store.dispatch(
                setSnackbarMessage(
                  'Document exists with same context. Please select different values to proceed',
                  'error'
                )
              )
          : updateDocumentData(docData, isSave);
      }
    } else {
      updateDocumentData(docData, isSave);
    }
  };

  const handleClosePHI = () => {
    setOpenPHI(false);
  };
  const { isLoading: getStudyLoad } = useGetStudiesQuery();

  return (
    <div className="document-upload-page">
      {dataGridComponent ? (
        <div>
          <SearchHierarchy
            searchData={getSearchHierarchy}
            row={row ? row : rowDetails.data[0]}
            isVersionCheck={IsVersionCheck}
          />
          {isDataAvailable !== null && isDataAvailable === false && !getStudyLoad ? (
            <div className="no-data-class">
              <h3>No Data access available!</h3>
            </div>
          ) : (
            <>
              <div className="card">
                <Grid container spacing={3}>
                  <Grid id="uploadFile" item md={12} sm={12} xs={12}>
                    {isEdit ? (
                      <div className="edit-file-section">
                        <div>
                          <InsertDriveFileIcon style={{ fontSize: '49px', color: '#979797' }} />
                        </div>
                        <Link>{row.isf_raw_file_name}</Link>
                        <Typography variant="h5" fontSize="20px">
                          Your file upload has been successfully initiated
                        </Typography>
                      </div>
                    ) : (
                      <DocumentUploadComponent
                        site={SearchHierarchyDetail?.data[0]?.Site}
                        onFileUploadSuccess={onFileUploadSuccess}
                        handleRejectedMessage={handleRejectedMessage}
                        setStyleUpload={setStyleUpload}
                        styleUpload={styleUpload}
                        isUploaded={isUploaded}
                        setUploaded={setUploaded}
                        isfLevel={metaData.isf_doc_level}
                        entity={metaData.isf_document_name}
                        metaData={metaData}
                        error={error}
                        setError={setError}
                        progress={progress}
                        setProgress={setProgress}
                        isFileUploading={isFileUploading}
                        setFileUploading={setFileUploading}
                      />
                    )}
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item md={4} sm={12} xs={12}>
                        <FormControl fullWidth margin="normal">
                          <TextField
                            required
                            id="standard-select-currency-native"
                            label="Document Name "
                            variant="standard"
                            inputProps={{
                              maxLength: 200
                            }}
                            onChange={e => handleDocumentName(e)}
                            value={metaData.isf_document_name?.trimLeft()}
                          />
                        </FormControl>

                        <FormControl fullWidth margin="normal">
                          <TextField
                            disabled={(isEdit ? false : disabled) || IsVersionCheck}
                            id="standard-select-currency-native"
                            label="Version Number"
                            variant="standard"
                            value={
                              isFileUploaded
                                ? parseFloat(metaData.isf_doc_version_number).toFixed(1)
                                : isEdit
                                ? parseFloat(metaData.isf_doc_version_number).toFixed(1)
                                : ''
                            }
                          ></TextField>
                        </FormControl>
                        <FormControl fullWidth margin="normal">
                          <TextField
                            disabled={
                              (isEdit ? false : !artifactName) || IsVersionCheck || !metaData?.isf_artifact_name
                            }
                            id="standard-select-currency-native"
                            label="Artifact Number"
                            variant="standard"
                            value={metaData.isf_artifact_number}
                          ></TextField>
                        </FormControl>
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <FormControl fullWidth margin="normal">
                          <Autocomplete
                            disabled={!SearchHierarchyDetail?.data[0]?.Site || IsVersionCheck}
                            disablePortal
                            readOnly={metaData.isf_doc_level === ''}
                            id="standard-select-currency-native"
                            options={list}
                            value={metaData.isf_artifact_name}
                            onChange={(event: any, newValue: string | null) => handleChangeArtifactName(newValue)}
                            renderInput={params => (
                              <TextField
                                {...params}
                                required
                                label="Artifact Name"
                                variant="standard"
                              />
                            )}
                          />
                        </FormControl>

                        <FormControl fullWidth margin="normal">
                          <TextField
                            disabled={
                              (isEdit ? false : !artifactName) || IsVersionCheck || !metaData?.isf_artifact_name
                            }
                            id="standard-select-currency-native"
                            label="Type"
                            variant="standard"
                            value={metaData.isf_document_type}
                          ></TextField>
                        </FormControl>

                        <FormControl fullWidth margin="normal">
                          <TextField
                            disabled
                            id="standard-select-currency-native"
                            label="Upload Date"
                            variant="standard"
                            value={
                              isFileUploaded
                                ? moment(new Date(metaData.isf_doc_date)).format(userPreferedDateFormat.toUpperCase())
                                : isEdit
                                ? moment(new Date(metaData.isf_doc_date)).format(userPreferedDateFormat.toUpperCase())
                                : ''
                            }
                          ></TextField>
                        </FormControl>
                      </Grid>
                      <Grid item md={4} sm={12} xs={12}>
                        <FormControl fullWidth margin="normal">
                          <TextField
                            disabled={
                              (isEdit ? false : !artifactName) || IsVersionCheck || !metaData?.isf_artifact_name
                            }
                            id="standard-select-currency-native"
                            label="Milestone"
                            variant="standard"
                            value={metaData.isf_doc_milestone}
                          ></TextField>
                        </FormControl>

                        <FormControl fullWidth margin="normal">
                          <TextField
                            disabled={
                              (isEdit ? false : !artifactName) || IsVersionCheck || !metaData?.isf_artifact_name
                            }
                            id="standard-select-currency-native"
                            label="Subtype"
                            variant="standard"
                            value={metaData.isf_document_subtype}
                          ></TextField>
                        </FormControl>

                        <FormGroup>
                          <FormControlLabel
                            sx={{ pl: 1.5 }}
                            control={
                              <Checkbox
                                checked={checked}
                                onChange={handleChangeCheck}
                                disabled={(isEdit ? (IsVersionCheck ? true : checked) : !isFileUploaded) || disablePHI}
                              />
                            }
                            label="Include PHI?"
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} mt={3}>
                      <Grid item xs={12} sm={12} md={12} display="flex" justifyContent="flex-end">
                        <Stack direction="row" spacing={2}>
                          <Button
                            onClick={handleDialogBox}
                            className="grey-btn"
                            disabled={
                              metaData.isf_doc_level === 'Site'
                                ? !metaData.isf_doc_level ||
                                  !metaData.isf_doc_study ||
                                  !metaData.isf_doc_country ||
                                  !metaData.isf_doc_site ||
                                  (!isFileUploaded &&
                                    !metaData.isf_artifact_number &&
                                    !metaData.isf_document_name?.trim())
                                : true
                            }
                          >
                            Cancel
                          </Button>
                          <PopupComponent
                            open={enable}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            className="confirm-modal"
                          >
                            <DialogTitle id="alert-dialog-title">{'Document upload?'}</DialogTitle>
                            <DialogContent sx={{ minWidth: 500 }}>
                              <DialogContentText id="alert-dialog-description">
                                {isFileUploaded
                                  ? 'Do you want to cancel document upload ?'
                                  : 'Do you want to cancel the page?'}
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={handleClearData} autoFocus className="grey-btn">
                                Yes
                              </Button>
                              <Button onClick={handleClose}>No</Button>
                            </DialogActions>
                          </PopupComponent>
                          {isEdit ? (
                            <Button
                              onClick={() => handleUpdateFile(metaData, true)}
                              disabled={
                                disableSave ||
                                !metaData.isf_document_name.trim() ||
                                !metaData.isf_doc_level ||
                                !SearchHierarchyDetail?.data[0]?.Study ||
                                !SearchHierarchyDetail?.data[0]?.Country ||
                                !SearchHierarchyDetail?.data[0]?.Site ||
                                !metaData.isf_artifact_number ||
                                metaData.isf_doc_study === '--' ||
                                metaData.isf_doc_country === '--' ||
                                metaData.isf_doc_site === '--'
                              }
                            >
                              Save
                            </Button>
                          ) : (
                            <Button
                              onClick={() => handleUploadFile(resData, metaData, artifactName, true, checked)}
                              disabled={
                                disableSubmit
                                  ? true
                                  : metaData.isf_doc_level === 'Site'
                                  ? !isFileUploaded ||
                                    !metaData.isf_doc_level ||
                                    !SearchHierarchyDetail?.data[0]?.Study ||
                                    !SearchHierarchyDetail?.data[0]?.Country ||
                                    !SearchHierarchyDetail?.data[0]?.Site ||
                                    !metaData.isf_artifact_number ||
                                    metaData.isf_doc_study === '--' ||
                                    metaData.isf_doc_country === '--' ||
                                    metaData.isf_doc_site === '--' ||
                                    !metaData.isf_document_name.trim()
                                  : true
                              }
                            >
                              Submit
                            </Button>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <DocumentUploadList
                result={result}
                rowCount={rowCount}
                setDataGridComponent={setDataGridComponent}
                setDocumentToDisplay={setDocumentToDisplay}
                setEditDoc={setEditDoc}
                handleDialogBox={handleDialogBox}
                loading={loading}
                setStyleUpload={setStyleUpload}
                setUploaded={setUploaded}
                documentValue={documentValue}
                ClearData={ClearData}
                setFileUploaded={setFileUploaded}
                ischecked={ischecked}
                setIsChecked={setIsChecked}
                pageSize={pageSize}
                setPage={setPage}
                setPageSize={setPageSize}
                page={page}
              />

              <PopupComponent maxWidth="sm" open={openVersion}>
                <VersionControl
                  resData={resData}
                  metaData={metaData}
                  selectData={selectData}
                  setSelectData={setSelectData}
                  setMetaData={setMetaData}
                  handleCloseVersion={handleCloseVersion}
                  artifactName={artifactName}
                  checked={checked}
                  ClearData={ClearData}
                  setUploaded={setUploaded}
                  documentValue={documentValue}
                  setStyleUpload={setStyleUpload}
                  setFileUploaded={setFileUploaded}
                  setDisablePHI={setDisablePHI}
                />
              </PopupComponent>

              <PopupComponent
                open={openPHI}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <IncludePHIDialog
                  setOpenPHI={setOpenPHI}
                  handleClosePHI={handleClosePHI}
                  setChecked={setChecked}
                  setDisablePHI={setDisablePHI}
                  metaData={metaData}
                  setMetaData={setMetaData}
                />
              </PopupComponent>
            </>
          )}
        </div>
      ) : (
        <div>
          {props.docViewer ? (
            ''
          ) : (
            <DocumentViewerComponent
              documentDetails={documentToDisplay}
              props={props}
              setDataGridComponent={setDataGridComponent}
            />
          )}
          {openEditDocVersion ? (
            <PopupComponent maxWidth="sm" open={openEditDocVersion}>
              <VersionControl
                resData={resData}
                metaData={metaData}
                selectData={documentDetail.data[0]}
                docViewer={true}
                setMetaData={setMetaData}
                handleCloseVersion={handleClosePropVersion}
                artifactName={artifactName}
                editedFmID={props.editedFmID}
                setOpenEditDocVersion={setOpenEditDocVersion}
              />
            </PopupComponent>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};
